module.exports = __webpack_public_path__ + "static/media/18.7eae0ef6.png";